'use strict';

bbw.directive.bbwBindCompile = ['$compile', function($compile) {

    return {
        scope: {
            value: '=bbwBindCompile'
        },
        link: function(scope, element, attrs) {
            var display = attrs.display || 'block';

            function update(input) {
                if (input) {
                    var vars = {};
                    if (angular.isArray(input)) {
                        vars = input;
                        input = '' + vars.shift();
                        var bbwMessage = ngtk.tools.object.getByPath(bbw.messages, input);
                        if (angular.isDefined(bbwMessage)) {
                            input = bbwMessage;
                        }
                    }
                    element.html(input);
                    $compile(element.contents())(angular.extend(vars, scope));
                    element.css('display', display);
                } else {
                    element.css('display', 'none');
                }
            }

            scope.$watch('value', update);
            update(scope.value);
        }
    }
}];
